import React, { PropsWithChildren, useContext } from 'react';
import { Collapse } from '../../legacy/Collapse';
import { identifyComponent } from '../../util';
import { CollapsibleSectionContext } from './Context';
import { getLabelId, getPanelId } from './utils';

export const CollapsibleSectionPanel: React.FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { collapsed, id, hasLabel, testId } = useContext(CollapsibleSectionContext);
  return (
    <Collapse
      data-component="CollapsibleSectionPanel"
      {...identifyComponent('collapsible-section-panel')}
      expanded={!collapsed}
    >
      <section
        aria-hidden={collapsed}
        id={getPanelId(id)}
        aria-labelledby={hasLabel ? getLabelId(id) : undefined}
        data-testid={testId && `${testId}-panel`}
      >
        {children}
      </section>
    </Collapse>
  );
};
